import React, { useEffect, useState } from "react"
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
  ButtonGroup,
  Button,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core"
import { useSelector, useDispatch } from "react-redux"
import groupsActions from "../../../../redux/actions/groups"
import { Close, Check, Delete } from "@material-ui/icons"

export default function ModalDelete() {
  const groups = useSelector((state) => state.groups)
  const dispatch = useDispatch()
  const [data, setData] = useState({})
  const [check, setCheck] = useState(false)
  useEffect(() => {
    if (groups.dataModal) {
      setData({
        name: groups.dataModal.name,
        address: groups.dataModal.address,
        datetimeCreated: new Date(
          groups.dataModal.createdAt
        ).toLocaleDateString(),
      })
    }
  }, [groups.dataModal])

  const handleClose = () => {
    dispatch(groupsActions.setDataModal(null))
    dispatch(groupsActions.setDeleteModal(false))
  }

  const handleDelete = () => {
    if (check) {
      dispatch(groupsActions.deleteGroup(groups.dataModal._id))
      handleClose()
    }
  }

  return (
    <Dialog
      open={groups.deleteModal}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      scroll={"body"}
    >
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h5">
              <Delete style={{ fontSize: 26, marginBottom: 5 }} /> Eliminar
              Grupo
            </Typography>
            <hr></hr>
            <Typography variant="body1">
              ¿Seguro que quieres eliminar el Grupo?{" "}
              <strong>Esta acción no puede deshacerse.</strong>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">Nombre: {data.name}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">Dirección: {data.address}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              Fecha de creación: {data.datetimeCreated}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={check}
                  onChange={(e) => setCheck(e.target.checked)}
                  color="primary"
                />
              }
              label="Confirmo que deseo eliminar este Grupo"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <ButtonGroup variant="contained" size="small">
          <Button
            color="secondary"
            onClick={() => handleClose()}
            startIcon={<Close />}
          >
            No, salir
          </Button>
          <Button
            color={check ? "primary" : "default"}
            onClick={() => handleDelete()}
            startIcon={<Check />}
          >
            Sí, eliminar
          </Button>
        </ButtonGroup>
      </DialogActions>
    </Dialog>
  )
}
